const mixin = {
    computed: {
        defaultRoute() {
            return '/';
        },

        currentReturnPathRoute() {
            const returnPath = this.$route.query.returnPath;
            return !returnPath || returnPath.includes('/error/') ? this.defaultRoute : returnPath;
        },
    },
};

export default mixin;
